import { Box, Button, CircularProgress, ThemeProvider } from '@mui/material';
import React, { useRef, useState } from 'react';
import './App.scss';
import Navigator from './navigator/Navigator';
import { theme } from './theme'; //ss
import { SnackbarProvider } from 'notistack';
import Notification from './components/Notifications/Notification';
import Loader from './components/Loader/Loader';
import { Loading } from './components/Loading';
import { ModalProvider } from './context/ModalProvider/ModalProvider';
function App() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const notistackRef = useRef<SnackbarProvider>(null);

  return (
    <Box sx={{ height: '100vh' }}>
      <ThemeProvider theme={theme}>
        <Loader setIsLoading={setIsLoading} />

        <SnackbarProvider
          ref={notistackRef}
          action={key => (
            <Button
              onClick={() => notistackRef?.current?.closeSnackbar(key)}
              style={{ color: '#fff', fontSize: '20px' }}
            >
              ✖
            </Button>
          )}
          maxSnack={4}
        >
          <Notification />

          <ModalProvider>
            <Loading isLoading={isLoading}>
              <Navigator />
            </Loading>
          </ModalProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </Box>
  );
}

export default App;
